"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stats = void 0;
var _Panel = require("./Panel");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Stats = exports.Stats = /*#__PURE__*/function () {
  function Stats() {
    var _this = this;
    _classCallCheck(this, Stats);
    _defineProperty(this, "dom", void 0);
    _defineProperty(this, "background", void 0);
    _defineProperty(this, "beginTime", void 0);
    _defineProperty(this, "mode", void 0);
    _defineProperty(this, "frames", void 0);
    _defineProperty(this, "panels", void 0);
    this.mode = 0;
    this.dom = document.createElement("div");
    this.panels = [];
    this.background = "#ffffff";
    this.initStyle();
    this.dom.addEventListener("click", function (event) {
      event.preventDefault();
      _this.showPanel(++_this.mode % _this.dom.children.length);
    }, false);
    this.beginTime = (performance || Date).now();
    this.frames = 0;
    this.panels.push(this.addPanel("FPS", "#4080f0", 1000, function (time, delta) {
      var res = {
        value: _this.frames * 1000 / delta,
        maxValue: 100
      };
      _this.frames = 0;

      //   console.log('FPS UPDATE')

      return res;
    }));
    this.panels.push(this.addPanel("MS", "#33A033", 0, function (time) {
      return {
        value: time - _this.beginTime,
        maxValue: 200
      };
    }));
    if (performance && performance.memory) {
      this.panels.push(this.addPanel("MB", "#ff0088", 100, function () {
        if (!performance || !performance.memory) {
          return;
        }
        var memory = performance.memory;
        var memoryFactor = 1048576;
        return {
          value: memory.usedJSHeapSize / memoryFactor,
          maxValue: memory.jsHeapSizeLimit / memoryFactor
        };
      }));
    }
    this.showPanel(0);
  }
  return _createClass(Stats, [{
    key: "addPanel",
    value: function addPanel(name, foreground, msRefresh, refreshCallback) {
      var panel = new _Panel.Panel(name, foreground, this.background, msRefresh, refreshCallback);
      this.addPanelObject(panel);
      return panel;
    }
  }, {
    key: "showPanel",
    value: function showPanel(id) {
      for (var i = 0; i < this.dom.children.length; i++) {
        var style = this.dom.children[i].style;
        if (style) {
          style.display = i === id ? "block" : "none";
        }
      }
      this.mode = id;
    }
  }, {
    key: "begin",
    value: function begin() {
      this.beginTime = (performance || Date).now();
    }
  }, {
    key: "end",
    value: function end() {
      var time = (performance || Date).now();
      this.frames++;
      var _iterator = _createForOfIteratorHelper(this.panels),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var panel = _step.value;
          panel.update(time);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return time;
    }
  }, {
    key: "update",
    value: function update() {
      this.beginTime = this.end();
    }
  }, {
    key: "addPanelObject",
    value: function addPanelObject(panel) {
      this.panels.push(panel);
      this.dom.appendChild(panel.dom);
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var _this2 = this;
      var darkMode = typeof matchMedia !== "undefined" ? matchMedia("(prefers-color-scheme: dark)") : undefined;
      var listener = function listener() {
        _this2.updateStyle();
      };
      if (darkMode !== null && darkMode !== void 0 && darkMode.addEventListener) {
        darkMode === null || darkMode === void 0 || darkMode.addEventListener("change", listener);
      } else if (darkMode !== null && darkMode !== void 0 && darkMode.addListener) {
        darkMode === null || darkMode === void 0 || darkMode.addListener(listener);
      }
      this.updateStyle();
    }
  }, {
    key: "updateStyle",
    value: function updateStyle() {
      //  const darkMode = typeof matchMedia !== "undefined" ? matchMedia("(prefers-color-scheme: dark)") : undefined;
      //  const darkModeMatch = darkMode?.matches ?? false;

      this.dom.style.position = "fixed";
      this.dom.style.top = "5px";
      this.dom.style.left = "5px";
      this.dom.style.cursor = "pointer";
      this.dom.style.opacity = "0.9";
      this.dom.style.zIndex = "10000";
      this.dom.style.borderRadius = "5px";

      // if (darkModeMatch) {
      this.background = "#000000";
      this.dom.style.boxShadow = "-4px -4px 10px 0 rgb(255, 255, 255, 0.7)";
      // } else {
      //     this.background = "#ffffff";
      //     this.dom.style.boxShadow = "-4px -4px 10px 0 rgb(0, 0, 0, 0.7)";
      // }
      var _iterator2 = _createForOfIteratorHelper(this.panels),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var panel = _step2.value;
          panel.background = this.background;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
}();
//# sourceMappingURL=Stats.js.map